import * as Common from "../../commons/common";

export class SearchCondition {
  student_code: string = ""
  name: string = ""
  nendo: string = ""
  subject_code: string = null
  sheet_type: number | string = ""
  report_no: number = null
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  grade: string = ""
  kumi: string = ""
  student_no: string = ""
  status: string = ""
  page: number = 1
  row_count: number =  100
}

export class StudentSubjectReport {
  id: number
  student_code: string
  student_name: string
  subject_code: string
  subject_name: string
  nendo: number
  report_no: number
  display_report_no: number
  report_code: string
  course_code: string
  campus_code: string
  class_code: string
  course_name: string
  campus_name: string
  class_name: string
  grade: string
  kumi: string
  student_no: number
  status: number
  publish_at: string
  std_deadline_at: string
  final_deadline_at: string
  is_checked: boolean = false

  constructor(x: any){
    const format = "YYYY/MM/DD HH:mm"
    this.id = x.id
    this.student_code = x.student_code
    this.student_name = x.student_name
    this.subject_code = x.subject_code
    this.subject_name = x.subject_name
    this.nendo = x.nendo
    this.report_no = x.report_no;
    this.display_report_no = Common.getStudentSubjectReportDisplayNo(x.report_no);
    this.report_code = x.report_code;
    this.course_code = x.course_code
    this.campus_code = x.campus_code
    this.class_code = x.class_code
    this.course_name = x.course_name
    this.campus_name = x.campus_name
    this.class_name = x.class_name
    this.grade = x.grade
    this.kumi = x.kumi
    this.student_no = x.student_no
    this.status = x.status
    this.publish_at = x.publish_at ? Common.formatDate(x.publish_at, format) : null;
    this.std_deadline_at = x.std_deadline_at ? Common.formatDate(x.std_deadline_at, format) : null;
    this.final_deadline_at = x.final_deadline_at ? Common.formatDate(x.final_deadline_at, format) : null;
  }
}
